/**
 * Status de uma execução da integração — a rodada que o administrador dispara ao liberar os
 * registros selecionados. Diferente do status do participante: aqui o assunto é a rodada
 * inteira, não o desfecho de cada pessoa (ver `IntegracaoParticipanteStatus`).
 *
 * Só `Concluido` foi confirmado pelo negócio; os demais são a expectativa do ciclo de uma
 * execução e precisam de confirmação quando o endpoint existir.
 */
export enum IntegracaoExecucaoStatus {
  EmAndamento = 'EM_ANDAMENTO',
  Concluido = 'CONCLUIDO',
  Erro = 'ERRO',
}
